var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7201 19.875C14.8763 20.0312 15.0951 20.0312 15.2513 19.875L18.2513 16.875C18.5013 16.625 18.3138 16.2187 18.0013 16.2187L15.7513 16.2187L15.7513 4.375C15.7513 4.15625 15.5638 4 15.3763 4L14.6263 4C14.4076 4 14.2513 4.15625 14.2513 4.375L14.2513 16.2187L11.9701 16.2187C11.6576 16.2187 11.4701 16.625 11.7201 16.875L14.7201 19.875ZM8.72009 4.09375L5.72009 7.09375C5.47009 7.34375 5.65759 7.75 5.97009 7.75L8.25134 7.75L8.25134 19.625C8.25134 19.8125 8.40759 20 8.62634 20L9.37634 20C9.56384 20 9.75134 19.8125 9.75134 19.625L9.75134 7.75L12.0013 7.75C12.3138 7.75 12.5013 7.34375 12.2513 7.09375L9.25134 4.09375C9.09509 3.9375 8.87634 3.9375 8.72009 4.09375Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.18351c0dfffc72d4d30b40d0e29cc16d.svg";
export { ForwardRef as ReactComponent };